import { render } from "./EditScheduledAppointment.vue?vue&type=template&id=320d4cf3"
import script from "./EditScheduledAppointment.vue?vue&type=script&lang=js"
export * from "./EditScheduledAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__